import React from "react";
import moment from "moment";

import { Alert, Box, Row, StaticField } from "@intech/web-ui";

import { LoadingComponent } from "../../../../components/LoadingComponent";

interface IProps {
  saldo: any | null
}

export const SaldoAtualizado: React.FC<IProps> = ({
  saldo
}) => {

  function DecimalDigitDisplay(Value: number, DecimalDigits: number) {
    if (Value === undefined)
      Value = 0;
    return (
      Value.toLocaleString('pt-br', { minimumFractionDigits: DecimalDigits, maximumFractionDigits: DecimalDigits })
    );
  }

  if (saldo !== null && saldo !== undefined) {
    return (
      <Box title={"Saldo Atualizado"} badgeText={"Posição de " + moment(saldo.DT_IND, "DD/MM/yyyy").format("MM/yyyy")}>

        <Row form>
          <StaticField
            value={saldo.TIPO_RENDA}
            title={"Tipo de Renda"}
            inline
            labelPosition={"up"}
          />

          <StaticField
            value={DecimalDigitDisplay(saldo.SALDO_ATUAL_GERAL, 8)}
            title={"Saldo Remanescente Em Cotas"}
            inline
            labelPosition={"up"}
          />
        </Row>

        <Row form>
          <StaticField
            value={saldo.SALDO_ATUAL_REAIS}
            title={"Saldo Remanescente Atualizado"}
            type={"money"}
            inline
            labelPosition={"up"}
          />

          <StaticField
            value={saldo.NUM_PARCELAS_PAG + (saldo.NUM_TOT_PARCELAS > 0 ? "/" + saldo.NUM_TOT_PARCELAS : "")}
            title={"Quantidade de Parcelas Pagas"}
            inline
            labelPosition={"up"}
          />
        </Row>

        <Row form>
          <StaticField
            value={DecimalDigitDisplay(saldo.VALOR_IND, 8)}
            title={`Valor da Cota (em ${moment(saldo.DT_IND, "DD/MM/yyyy").format("DD/MM/yyyy")})`}
            inline
            labelPosition={"up"}
          />

        </Row>

        {saldo.CD_TIPO_RENDA === "5" && <Box>
          <div className={"text-center"}>
            O tempo previsto de exaurimento da sua renda é de:
          </div>
          <br />
          <div className={"text-center text-primary"}>
            {saldo.NUM_TOT_PARCELAS - saldo.NUM_PARCELAS_PAG} meses
          </div>
        </Box>}

        {saldo.CD_TIPO_RENDA !== "5" && <Alert type="info">
          {saldo.CD_TIPO_RENDA === "4" ?
            "A renda será paga enquanto o assistido estiver vivo, observado que o valor será recalculado anualmente no mês de novembro, de acordo com a idade e saldo da reserva remanescente."
            : "Tempo de Exaurimento em construção."}
        </Alert>}

      </Box>
    )
  }

  return (
    <LoadingComponent />
  );
}